import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ExtraKey } from '@app/models/enums/extra-key.enum';
import { Contract } from '@app/models/settings/contract';
import { IncentiveModalComponent } from '@components/incentive-modal/incentive-modal.component';
import { BaseComponent } from '@core/component/base/base.component';
import { I18nService } from '@core/services/i18n/i18n.service';
import { isNumber, tranType } from '@core/utils';
import { ROUTER_UTILS } from '@core/utils/router.utils';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '@services/auth.service';
import { UserService } from '@services/user.service';
import { cloneDeep, toNumber } from 'lodash';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { Observable } from 'rxjs';
@Component({
  standalone: true,
  selector: 'app-user-profile',

  imports: [CommonModule, FormsModule, TranslateModule, NzBadgeModule, NzDropDownModule, NzIconModule, NzInputModule, NzMenuModule, IncentiveModalComponent],
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.less'],
})
export class UserProfileComponent extends BaseComponent implements OnInit {

  path = ROUTER_UTILS;

  @ViewChild('incentiveModal')
  incentiveModal!: IncentiveModalComponent;
  incentiveCount = 0;
  incentiveEnable = false;

  isLoggedIn$!: Observable<boolean>;

  get disableUserProfile(): boolean {
    return location.pathname.includes(this.path.business.bi);
  }

  constructor(authService: AuthService, i18nService: I18nService, private router: Router, private userService: UserService) {
    super(authService, i18nService);
  }

  ngOnInit(): void {
    this.getUserContracts();
    this.isLoggedIn$ = this.authService.isLoggedInSubject;
    this.authService.attrCfgSubject.subscribe(attrCfg => {
      if (tranType(this.attrCfg[ExtraKey.ICIS_ENABLE]) === true) {
        this.incentiveEnable = true;
        let timeout = toNumber(this.attrCfg[ExtraKey.ICIS_SHOW_DELAY]) * 1000;
        if (!isNumber(timeout)) {
          timeout = 10000;
        }
        setTimeout(() => {
          this.showIncentiveModal();
        }, timeout);
      } else {
        this.incentiveEnable = false;
        this.incentiveCount = 0;
      }
    });
  }

  navMenuClick(router: string) {
    this.router.navigate([router]);
  }

  logout() {
    this.authService.signOut();
  }

  onInentiveModalClose(showCount?: boolean): void {
    this.incentiveCount = showCount ? 1 : 0;
  }

  showIncentiveModal(): void {
    this.incentiveCount = 0;
    if (this.incentiveModal) {
      this.incentiveModal.handleShow();
    }
  }

  originalContractList: Contract[] = [];
  contractList: Contract[] = [];

  getUserContracts() {
    this.userService.getUserContracts().subscribe(res => {
      this.originalContractList = res;
      this.contractList = cloneDeep(this.originalContractList);
    });
  }

  switchContract(contractId: number, isDisabled: boolean) {
    if (isDisabled) {
      return;
    }
    this.userService.switchContract(contractId).subscribe(res => {
      const url =
        location.pathname.replace(this.router.url.split('?')[0], '') +
        this.router.serializeUrl(this.router.createUrlTree([this.path.business.dashboard]));

      location.href = url;
    });
  }

  isVisable: boolean = false;

  searchContractName = '';

  searchContract(searchContractName: string) {
    this.contractList = this.originalContractList.filter(contract => contract.contractName.toLowerCase().includes(searchContractName.toLowerCase()));
  }

  getContractsDropdownStyle() {
    const maxSize = 10;
    const style = {
      height: `${Math.min(this.originalContractList.length, maxSize) * 32}px`,
      overflow: this.originalContractList.length > maxSize ? 'auto' : 'hidden',
    };
    return style;
  }
}
